export default __webpack_public_path__ + "static/media/Copy.5b843f02.svg";